import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=eea4d4ae&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=eea4d4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea4d4ae",
  null
  
)

export default component.exports